import React from 'react';
import { updateSpace } from '../../app-main/actions/space';
import { SubmissionError } from 'redux-form';
import { get, filter } from 'lodash';
import { FormattedMessage } from 'react-intl';

const onSubmitTag = (values = {}, dispatch, props) => {
  const { space = {}, accessToken } = props;
  const spaceId = get(space, 'data._id');
  const types = get(values, 'types', {});
  let payload = {};

  if ('true' === values.is_available) {
    payload.parking_info = {
      types: filter(types, (value) => value),
      description: values.description,
      is_available: true
    };
  } else {
    payload.parking_info = {
      is_available: false
    };
  }

  if ('true' === values.has_surveillance) {
    payload.surveillance_info = {
      has_surveillance: true,
      description: values.surveillance_description
    }
  } else {
    payload.surveillance_info = {
      has_surveillance: false
    }
  }

  if (values.type_tag) {
    payload = {
      ...payload,
      type_tag: values.type_tag
    };
  }

  payload.overnight_stays = values.overnight_stays === 'true';

  const errorMessage = <FormattedMessage id="hosting.on_submit_tag.error_message" defaultMessage="Submission failed. Please refresh and try again." />;

  return dispatch(updateSpace(spaceId, accessToken, payload))
    .then(() => {
      const spaceId = get(props, 'space.data._id');

      analyticsIntegrations.trackEvent('Space Type Saved', {
        space_id: spaceId,
        host_id: get(props, 'profile.SSOid'),
        user_id: get(props, 'profile.SSOid'),
        space_type: get(values, 'type_tag'),
        overnight_stays: get(props, 'space.data.overnight_stays'),
        timestamp: Date.now(),
        created_by: 'host'
      });

      window.location.href = `/your-space/${spaceId}/space-details`;
    })
    .catch(() => {
      throw new SubmissionError({ _error: errorMessage });
    });
};

export default onSubmitTag;
